import { h, Component } from 'preact'
import { connect } from 'react-redux'

import Input from '../../../shared/components/Input.jsx'
import Button from '../../../shared/components/Button.jsx'

import { request } from '../state/actions/email.js'

import '../style/components/EmailStep.less'

class EmailStep extends Component {

	constructor(props) {
		super(props)

		this.state = {
			firstName: '',
			firstNameValid: false,
			lastName: '',
			lastNameValid: false,
			emailAddress: '',
			emailValid: false,
			phoneNumber: '',
			phoneValid: false
		}
	}

	handleInputFirstName = e => {
		this.setState({
			firstName: e.target.value,
			firstNameValid: e.target.checkValidity()
		})
	}

	handleInputLastName = e => {
		this.setState({
			lastName: e.target.value,
			lastNameValid: e.target.checkValidity()
		})
	}

	handleInputEmail = e => {
		this.setState({
			emailAddress: e.target.value,
			emailValid: e.target.checkValidity()
		})
	}

	handleInputPhone = e => {
		this.setState({
			phoneNumber: e.target.value,
			phoneValid: e.target.checkValidity()
		})
	}

	handleSubmit = e => {
		e.preventDefault()

		const { firstName, lastName, emailAddress, phoneNumber } = this.state
		const { source } = this.props
		this.props.request(firstName, lastName, emailAddress, phoneNumber, source)
	}

	render(props, { firstName, firstNameValid, lastName, lastNameValid, emailAddress, emailValid, phoneNumber, phoneValid }) {

		const formValid = firstNameValid && lastNameValid && emailValid && phoneValid

		return (
			<section class="EmailStep">
				<h2>Request Demo Access</h2>
				<p>Enter your information to request demo access.</p>

				<form spellcheck="false" onsubmit={ this.handleSubmit }>
					<label for="firstName">First Name</label>

					<Input
						id="firstName"
						type="text"
						errors={{
							valueMissing: 'Please enter your first name'
						}}
						value={ firstName }
						placeholder="John"
						oninput={ this.handleInputFirstName }
						onchange={ this.handleInputFirstName }
						required
					/>

					<label for="lastName">Last Name</label>

					<Input
						id="lastName"
						type="text"
						errors={{
							valueMissing: 'Please enter your last name'
						}}
						value={ lastName }
						placeholder="Doe"
						oninput={ this.handleInputLastName }
						onchange={ this.handleInputLastName }
						required
					/>

					<label for="email">Email Address</label>

					<Input
						id="email"
						type="email"
						errors={{
							valueMissing: 'Please enter your email address',
							typeMismatch: 'Please enter a valid email address',
						}}
						value={ emailAddress }
						placeholder="you@company.com"
						oninput={ this.handleInputEmail }
						onchange={ this.handleInputEmail }
						required
					/>

					<label for="phone">Phone Number</label>

					<Input
						id="phone"
						type="tel"
						errors={{
							valueMissing: 'Please enter your phone number',
							patternMismatch: 'Please enter a valid phone number'
						}}
						value={ phoneNumber }
						placeholder="555-123-4567"
						pattern="[\d\s\-\+\(\)\.]{10,}"
						oninput={ this.handleInputPhone }
						onchange={ this.handleInputPhone }
						required
					/>

					<Button type="submit" disabled={ !formValid }>
						Continue
					</Button>
				</form>
			</section>
		)
	}
}

const mapStateToProps = state => ({
	source: state.tracking.source
})

const mapDispatchToProps = dispatch => ({
	request: (firstName, lastName, emailAddress, phoneNumber, source) => dispatch(request(firstName, lastName, emailAddress, phoneNumber, source))
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(EmailStep)
